import { GiphyFetch } from '@giphy/js-fetch-api';
import { IGif } from '@giphy/js-types';
import { Carousel } from '@giphy/react-components';
import { SyntheticEvent } from 'react';

import { overlayClassName, resultsClassName } from './styles';

export interface Props {
  handleClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void;
  search: string;
}

const Results = ({ handleClick, search }: Props) => {
  const gf = new GiphyFetch('KFGaWQaXQ1QXQFKtWKEuPBo0KWd6PKEM');

  const Overlay = () => <div className={overlayClassName} />;

  return (
    <div className={resultsClassName}>
      <Carousel
        key={search}
        fetchGifs={
          search
            ? (offset) => gf.search(search, { offset, limit: 10 })
            : (offset) => gf.trending({ offset, limit: 10 })
        }
        hideAttribution={true}
        gifHeight={160}
        gutter={6}
        onGifClick={handleClick}
        overlay={Overlay}
      />
    </div>
  );
};

Results.displayName = 'Results';

export default Results;
